/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import { NavLink } from 'react-router-dom';

function generateDecimalRegex(maxDecimals) {
  return new RegExp(`^[0-9]*\\.?[0-9]{0,${maxDecimals}}$`);
}

export default function PercentageInput({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  link,
  tabindex,
  isVisible,
  readOnly,
  limitDecimals,
}) {
  const inputRef = useRef();

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1) {
      inputRef.current.focus();
    }
  }, [tabindex, isVisible]);

  return (
    <div>
      <label className="block text-sm font-medium mb-1" htmlFor={name}>
        {label}
      </label>
      <div className="relative">
        <input
          readOnly={readOnly}
          className={classNames('form-input w-full pr-8', {
            'border-0 shadow-none': readOnly,
          })}
          ref={inputRef}
          onKeyDown={(event) => {
            if (
              isNaN(event.key) &&
              event.key !== 'Backspace' &&
              event.key !== 'Delete' &&
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight' &&
              event.key !== 'Tab' &&
              event.key !== '.'
            ) {
              event.preventDefault();
            }
          }}
          id={name}
          name={name}
          value={readOnly ? `${value}%` : value}
          onChange={(event) => {
            if (limitDecimals) {
              const regex = generateDecimalRegex(limitDecimals);

              if (!regex.test(event.target.value)) {
                return;
              }
            }

            onChange(event);
          }}
          onBlur={onBlur}
          type={type || 'text'}
          min={type === 'number' ? 0 : undefined}
          tabIndex={tabindex}
        />
        {!readOnly && (
          <div className="absolute inset-0 left-auto flex items-center pointer-events-none">
            <span className="text-sm text-slate-400 dark:text-slate-500 font-medium px-3">
              %
            </span>
          </div>
        )}
      </div>
      {link && (
        <NavLink
          className="inline-block w-full text-sm underline hover:no-underline text-right"
          to={link.url}
          tabIndex={-1}
        >
          {link.title}
        </NavLink>
      )}
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
